import { Chip } from "@mui/material";
import { BranchInvoiceState, IBranchInvoice } from "../interfaces/common/branch-invoices";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ErrorIcon from '@mui/icons-material/Error';
import CancelIcon from '@mui/icons-material/Cancel';
import PendingIcon from '@mui/icons-material/Pending';

export const showBranchInvoiceState = (status: BranchInvoiceState) => {
    switch (status) {
        case BranchInvoiceState.PENDING_PAYMENT:
            return <Chip size="small" icon={<PendingIcon />} label="Pending Payment" color="warning" />;
        case BranchInvoiceState.PAYMENT_SCHEDULED:
            return <Chip size="small" icon={<HourglassBottomIcon />} label="Payment Scheduled" color="info" />;
        case BranchInvoiceState.COLLECTED_BY_DRIVER:
            return <Chip size="small" icon={<LocalShippingIcon />} label="Collected By Driver" color="primary" />;
        case BranchInvoiceState.IN_PROGRESS:
            return <Chip size="small" icon={<HourglassBottomIcon />} label="In Progress" color="info" />;
        case BranchInvoiceState.PAID:
            return <Chip size="small" icon={<CheckCircleIcon />} label="Paid" color="success" />;
        case BranchInvoiceState.AWAITING_RETURN:
            return <Chip size="small" icon={<LocalShippingIcon />} label="Awaiting Return" color="warning" />;
        case BranchInvoiceState.FAILED:
            return <Chip size="small" icon={<ErrorIcon />} label="Failed" color="error" />;
        case BranchInvoiceState.CANCELLED:
            return <Chip size="small" icon={<CancelIcon />} label="Cancelled" color="default" />;
        default:
            return <Chip size="small" label={status} />;
    }
};

export const canCancelBranchInvoice = (invoice: IBranchInvoice): boolean => {
    return invoice.status === BranchInvoiceState.PENDING_PAYMENT || 
           invoice.status === BranchInvoiceState.PAYMENT_SCHEDULED ||
           invoice.status === BranchInvoiceState.FAILED;
};

export const canSchedulePayment = (invoice: IBranchInvoice): boolean => {
    return invoice.status === BranchInvoiceState.PENDING_PAYMENT || 
           invoice.status === BranchInvoiceState.FAILED;
};


